import { render, staticRenderFns } from "./PromoHeader.vue?vue&type=template&id=69620004&scoped=true"
import script from "./PromoHeader.vue?vue&type=script&lang=js"
export * from "./PromoHeader.vue?vue&type=script&lang=js"
import style0 from "./PromoHeader.vue?vue&type=style&index=0&id=69620004&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69620004",
  null
  
)

export default component.exports